import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import { observable, computed } from 'mobx';
import copy from '@src/components/copy';
import AntdMessage from '@src/components/antd/message';

let swiperRef = null;
class OpenBetaHighlightsStore extends BaseStore {
  @observable swiperData = [];
  @observable prizeList = [];
  @observable realIndex = 0;
  @observable prize_code = '';

  @computed
  get params() {
    const that = this;
    return {
      loop: true,
      observer: true,
      observeChildren: true,
      on: {
        init: function () {
          swiperRef = this;
        },
        slideChangeTransitionEnd: function () {
          that.realIndex = this.realIndex;
        }
      }
    };
  }

  changeSwiper = type => {
    if (type === 'prev') {
      swiperRef.slidePrev();
    } else if (type === 'next') {
      swiperRef.slideNext();
    } else {
      swiperRef.slideTo(type + 1);
    }
  };

  updateSwiper = () => {
    swiperRef.update();
  };

  copyCdk = () => {
    if (!this.prize_code) {
      AntdMessage.error('暂无CDK');
      return;
    }
    copy(this.prize_code);
  };

  use() {
    super.use();

    useMount(async () => { });
  }
}

export default OpenBetaHighlightsStore;
